import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';
import { styled } from '@linaria/react';

export const SectionWrapper = styled.div`
  margin-top: 2.5rem;
  text-align: left;
`;

export const SectionTitle = styled.div`
  ${theme.typography.titleSmall}
  font-size: 18px;
`;

export const SectionSubtitle = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
  margin-top: 0.25rem;
`;

export const ProductList = styled.ul`
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
`;

export const ProductRow = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
  padding: 1rem 0;
  border-top: 1px solid ${theme.color.border.divider};

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
`;

export const Lead = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  min-width: 0;

  @media (min-width: ${breakpoints.md}) {
    flex: 1;
    width: auto;
  }
`;

export const ProductLink = styled.a`
  display: block;
  flex-shrink: 0;
  width: 4.6875rem;
  height: 4.6875rem;
`;

export const ProductImage = styled(CdnImage)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ProductInfo = styled.a`
  flex: 1;
  min-width: 0;
  color: ${theme.color.text.primary};
  text-decoration: none;
  ${theme.typography.labelRegular400}
`;

export const ProductName = styled.span`
  strong {
    font-weight: 700;
  }
`;

export const ProductDescription = styled.div`
  margin-top: 0.25rem;
  color: ${theme.color.text.secondary};
  ${theme.typography.labelRegular400}
`;

export const WriteReviewButton = styled(Button)`
  flex-shrink: 0;
  align-self: flex-end;
  text-transform: none;
  white-space: nowrap;
  width: auto;

  @media (min-width: ${breakpoints.md}) {
    align-self: center;
    width: auto;
  }
`;

export const Footer = styled.div`
  margin-top: 1rem;
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
`;

export const MyReviewsLink = styled.a`
  position: relative;
  display: inline-block;
  color: ${theme.color.text.primary};
  text-decoration: underline;
  ${theme.typography.labelRegular}

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 44px;
  }
`;
